// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
var fechaActual = (new Date(Date.now() - tzoffset)).toISOString().split("T")[0];  

// Función del router
const ActivitySearchForm = (params) => {    

  useEffect(() => {                 
    console.log("Formulario de búsqueda cargado correctamente.")        
    cargaActividadInicial()
  }, []);

  function cargaActividadInicial(){
    
    var fechaActual = new Date();
    
    var añoActual = fechaActual.getFullYear();
    var mesActual = (fechaActual.getMonth()+1);
    var diaActual = fechaActual.getDate();
    
    if (mesActual < 10){ mesActual = "0"+mesActual;	}
    if (diaActual < 10){ diaActual = "0"+diaActual;	}
    
    var fechaActualFormateada = añoActual+"-"+mesActual+"-"+diaActual;
    var fechaDesdeFormateada = añoActual+"-"+mesActual+"-"+diaActual; //Por ahora seteo datos al día actual, ya meteré rangos
    var horaDesdeFormateada = "00:00";
    var horaHastaFormateada = "23:59";
    
    document.getElementById("fechaDesde").value = fechaDesdeFormateada;
    document.getElementById("fechaHasta").value = fechaActualFormateada;
    document.getElementById("horaDesde").value = horaDesdeFormateada;
    document.getElementById("horaHasta").value = horaHastaFormateada;

  }

  return (

    <fieldset >

      <fieldset className="vertical gap-02">
        
        <fieldset className="horizontal gap-04">
                        
          <div className="col"> 
            <fieldset className="date">
              <label htmlFor="labelFechaDesde"><b>Fecha desde</b></label>	
              <fieldset className="icon-wrapper">
                <input type="date" id="fechaDesde" name="fechaDesde" max={fechaActual}/>
              </fieldset>
            </fieldset>
          </div>
          
          <div className="col">
            <fieldset className="time">
              <label htmlFor="labelHoraDesde"><b>Hora desde</b></label>		
              <div className="icon-wrapper">
                <input type="time" id="horaDesde" name="horaDesde" min="00:00" max="23:59" />
              </div>
            </fieldset>
          </div>
          
        </fieldset>

        <fieldset className="horizontal gap-04">
            
          <div className="col">
            <fieldset className="date">
              <label htmlFor="labelFechaHasta"><b>Fecha hasta</b></label>		
              <fieldset className="icon-wrapper">
                <input type="date" id="fechaHasta" name="fechaHasta" max={fechaActual}/>		
              </fieldset>
            </fieldset>
          </div>

          <div className="col">
            <fieldset className="time">
              <label htmlFor="labelHoraHasta"><b>Hora hasta</b></label>		
              <div className="icon-wrapper">
                <input type="time" id="horaHasta" name="horaHasta" min="00:00" max="23:59" />
              </div>
            </fieldset>
          </div>
          
        </fieldset>

        <div className="col">
          <ul className="actions horizontal">            
            <li className="fill"><button id="actualizarDatosHistoricos" className="button primary full-width" type="button" onClick={ () => params.cargarDatosActividadInstalacion()}><b>Consultar</b></button></li>                  
          </ul>
        </div>

      </fieldset>

    </fieldset>
  )  
    
}

export default ActivitySearchForm